import * as React from 'react';
import { Route, Routes } from 'react-router-dom-v5-compat';

import Error404Container from 'af-root/scenes/Error/error404';

import { workOrderPrefix } from 'af-routes/client';

import FieldReportsList from './FieldReportsList';
import WorkOrdersTable from './WorkOrdersList';

const ChildPaths = {
	workOrders: 'workOrders',
	workOrder: `workOrder/${workOrderPrefix}`,
};

const FieldReports: React.FC = () => {

	return (
		<Routes>
			<Route element={<WorkOrdersTable />} path={ChildPaths.workOrders}></Route>
			<Route element={<FieldReportsList />} path={ChildPaths.workOrder}></Route>
			<Route element={<Error404Container />} path="*" />
		</Routes >
	);

};

export default React.memo(FieldReports);
